/* unplugin-vue-components disabled */import { render } from "./reasoning-head.vue?vue&type=template&id=5db7ff70&scoped=true"
import script from "./reasoning-head.vue?vue&type=script&lang=js"
export * from "./reasoning-head.vue?vue&type=script&lang=js"

import "./reasoning-head.vue?vue&type=style&index=0&id=5db7ff70&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db7ff70"],['__file',"src/components/ai-chat-v2/ai-assistant/research/reasoning-head.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5db7ff70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5db7ff70', __exports__)) {
    api.reload('5db7ff70', __exports__)
  }
  
  module.hot.accept("./reasoning-head.vue?vue&type=template&id=5db7ff70&scoped=true", () => {
    api.rerender('5db7ff70', render)
  })

}


export default __exports__